<template>
  <div id="ms_header_downside" class="parent_div">
    <div id="header_main" class="wrapper">
      <div class="corp_logo" v-if="!isMenu">
        <img :src="getImage('common/logo_domans.svg')" width="100%" height="55px" />
      </div>
      <div id="menu_area" v-else-if="isMenu">
        <div class="toggle" @click="onMenu()" @mouseover="isOnMenu=true" @mouseout="isOnMenu=false"> <span></span> <span></span></div>
        <div class="menu_text small_text bold">メニュー</div>
        <nav id="main_nav" v-bind:class="{active: isMenuActive}" @mouseover="isOnMenu=true" @mouseout="isOnMenu=false">
          <dd-menu></dd-menu>
        </nav>
      </div>
      <div class="corp_logo" v-else>
      </div>
      <div>
        <div id="profit_disp" v-if="isDcPriceDisp">卸価格が表示されています</div>
      </div>
      <!-- <div id="space" style="flex-shrink: 1"></div> -->
      <div id="logo">
        <img :src="this.getImage('common/logo.png')" @click="onLogo()"/>
        <div class="small_text bold">My size, My lifestyle.</div>
      </div>
      <!-- <div id="space" style="flex-shrink: 1"></div> -->
      <div class="icon_area">
        <div>
          <router-link to="/mmstyle/support/input">
            <img :src="this.getImage('common/mail_red.svg')" />
            <div class="small_text bold">お問い合わせ</div>
          </router-link>
        </div>
        <div v-if="isCart">
          <router-link to="/mmstyle/cart">
            <img :src="dispCartImg" />
            <div class="small_text bold">カート</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../../utils/App'
import {mapActions, mapState} from 'vuex'
import {PAYMENT_STATUS} from '../../../constants/Type'
import DDMenu from '../../components/top/Menu'
import {DC_STORAGE_KEY} from '../../../constants/App'

export default {
  name: 'DcHeader',
  components: {
    'dd-menu': DDMenu
  },
  props: {
    headerType: {
      type: Number,
      default: 2
    },
    headerSubContentType: {
      type: Number,
      default: 0
    },
    isDcPriceDisp: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isMenuActive: false,
      isOnMenu: false
    }
  },
  computed: {
    ...mapState({
      cartData: state => state.cartData
    }),
    isMenu: function () {
      if (this.headerType === 2) return true
      return false
    },
    isCart: function () {
      if (this.headerType === 2 && this.isLogin) return true
      return false
    },
    isLogin: function () {
      return (this.user.userId !== undefined)
    },
    isDispSupport: function () {
      return this.headerTelContentType === 0
    },
    nowList: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return {}
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
    },
    dispCartImg: function () {
      if (this.nowList.length <= 0) {
        return this.getImage('common/cart_red.svg')
      } else {
        return this.getImage('common/cart_red_badge.svg')
      }
    }
  },
  methods: {
    ...mapActions({ getCartData: 'loadCartData' }),
    onMenu: function () {
      if (this.isMenuActive) {
        this.isMenuActive = false
      } else {
        this.isMenuActive = true
      }
    },
    close: function () {
      if (this.isOnMenu || !this.isMenuActive) return
      this.isMenuActive = false
    },
    onLogo: function () {
      if (this.isLogin) {
        this.$router.push({
          name: 'DcTop'
        })
      } else {
        this.$router.push({
          name: 'DcLogin'
        })
      }
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  mounted: function () {
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    if (this.isLogin) {
      this.$store.dispatch('loadCartData', {reload: true})
    }
  }
}
</script>
<style src="../../css/dcstyle.scss" lang="scss" scoped></style>
<style src="../../css/dc-common.scss" lang="scss" scoped></style>
<style src="../../css/dcheader.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/common/DcHeader.vue